import { queryClient } from '../index';
import { documentsKeys } from './documents.keys';
export const documentOptimisticUpdate = (inputDoc) => {
    queryClient.setQueryData(documentsKeys.all(), (prev) => {
        return {
            ...prev,
            docs: [
                ...prev.docs.map((doc) => doc.id === inputDoc.id
                    ? { ...doc, api_status: inputDoc.api_status, index_state: inputDoc.index_state }
                    : doc)
            ]
        };
    });
};
export const documentsQueryOptimisticAdd = (newDoc) => {
    queryClient.setQueryData(documentsKeys.all(), (prev) => {
        if (!prev) {
            return { docs: [newDoc], current_page: 1, total: 1 };
        }
        if (prev.docs.some((doc) => doc.id === newDoc.id)) {
            return prev;
        }
        return { ...prev, docs: [newDoc, ...prev.docs], total: prev.total + 1 };
    });
};
//# sourceMappingURL=documents.query.update.js.map